import React from 'react'
import { Container } from 'reactstrap';

const Empty = () => {
    return (
        <Container fluid>
            <h5>
                Aquí podras encontrar información útil acerca de las funcionalidades que ofrece el panel de gestión E-SIGE.
                No obstante, se recuerda que ante inconvenientes no cubiertos por la presente documentación,
                se recomienda cargar un ticket detallado en nuestro <a className="text-dark font-weight-bold" target="_blank" href="https://accesoclientes.paradigma.com.ar">Sistema de Tickets</a>.
            </h5>
        </Container>
    )
}
export default Empty;


// WEBPACK FOOTER //
// ./src/views/Ayuda/Paneles/Empty.js